import type { Theme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    width: '98%',
    margin: '20px 20px 30px 20px',
  },
  searchAndButton: {
    display: 'flex',
  },
  addFieldButton: {
    padding: '40px 0 0 30px',
  },
  fieldSearchBox: {
    position: 'sticky',
    top: 0,
    padding: '10px',
    width: '200px',
    borderRadius: theme.shape.borderRadius,
    margin: '40px 50px 0px auto',
    backgroundColor: theme.palette.grey[500],
  },
  fieldMapTable: {
    backgroundColor: theme.palette.background.paper,
    '& tr:nth-of-type(odd)': {
      backgroundColor: alpha(theme.palette.common.white, 0.04),
    },
  },
  tableContainer: {
    overflowY: 'scroll', // Enable vertical scrolling
    '&::-webkit-scrollbar': {
      display: 'none', // Hide scrollbar in WebKit browsers (Chrome, Safari)
    },
    '-ms-overflow-style': 'none', // Hide scrollbar in Internet Explorer and Edge
    'scrollbar-width': 'none', // Hide scrollbar in Firefox
  },
  searchInput: {
    width: '100%',
  },
}));

export default useStyles;
